module.exports = __webpack_public_path__ + "img/cta.cb951cf2.jpg";